export const DARK_TEXT = '#222648';
export const WHITE = '#FFFFFF';
export const OVERLAY_BACKGROUND = 'rgba(16, 22, 43, 0.4)';
